'use client';

import useTranslation from 'next-translate/useTranslation';
import { NotificationOutline } from '@eqi-investimentos/icons/web';
import { Box, Button, Flex, Heading, Text } from '@eqi-investimentos/react';
import { FINANCIAL_PLANNING_REGISTER, RegisterDrawer } from './RegisterDrawer';
export const FinancialPlanningRegister = () => {
  const {
    t
  } = useTranslation('common');
  const handleClick = () => {
    window.dispatchEvent(new Event(`open-chakra-modal-${FINANCIAL_PLANNING_REGISTER}`));
  };
  return <>
      <RegisterDrawer data-sentry-element="RegisterDrawer" data-sentry-source-file="index.tsx" />
      <Flex flexDir="column" gap="5" p="32" w="calc(100% - 2rem)" borderWidth="1px" borderColor="border.secondary" borderRadius="6" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <NotificationOutline boxSize={32} color="content.brand" data-sentry-element="NotificationOutline" data-sentry-source-file="index.tsx" />
        <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Heading as="h2" fontSize="lg" fontWeight="normal" lineHeight="8" color="content.primary" data-sentry-element="Heading" data-sentry-source-file="index.tsx">
            {t('screens.financialPlanning.register.title')}
          </Heading>
          <Text mt="2" fontSize="sm" lineHeight="6" fontWeight="normal" color="content.tertiary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t('screens.financialPlanning.register.description')}
          </Text>
          <Text mt="6" fontSize="sm" lineHeight="6" fontWeight="normal" color="content.tertiary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t('screens.financialPlanning.register.ctaText')}
          </Text>
        </Box>
        <Button onClick={handleClick} justifyContent="center" h="3.25rem" w="16.25rem" borderRadius="base" data-sentry-element="Button" data-sentry-source-file="index.tsx">
          <Text fontSize="sm" lineHeight="5" data-sentry-element="Text" data-sentry-source-file="index.tsx">
            {t('screens.financialPlanning.register.ctaButton')}
          </Text>
        </Button>
      </Flex>
    </>;
};